import { render, staticRenderFns } from "./PremiumTopOffer.vue?vue&type=template&id=ff63b2ca&scoped=true&"
import script from "./PremiumTopOffer.vue?vue&type=script&lang=js&"
export * from "./PremiumTopOffer.vue?vue&type=script&lang=js&"
import style0 from "./PremiumTopOffer.vue?vue&type=style&index=0&id=ff63b2ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff63b2ca",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardTitle, BCardText, BButton, BCardBody, BCard} from 'bootstrap-vue'
    installComponents(component, {BCardTitle, BCardText, BButton, BCardBody, BCard})
    

export default component.exports